import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { useBusinessSettings } from "../lib/businessSettings";

export default function Footer() {
  const { t, lang } = useI18n();
  const { settings } = useBusinessSettings();
  const logoSrc = lang === "pl" ? "/brand/logo-pl.png" : "/brand/logo-en.jpg";
  const address = lang === "pl" ? settings.address_pl : settings.address_en;
  return (
    <footer className="border-t border-slate-200 bg-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <img
            src={logoSrc}
            alt="LocalH2O"
            className="h-28 w-auto select-none"
            draggable={false}
            data-testid={`footer-logo-${lang}`}
          />
          <p className="mt-4 text-sm text-slate-600 max-w-md leading-relaxed">
            {t("footer.tagline")}
          </p>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3">{t("contact.title")}</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li className="flex items-center gap-2" data-testid="footer-address">
              <MapPin className="w-4 h-4 text-sky-600" />
              {address}
            </li>
            <li className="flex items-center gap-2" data-testid="footer-email">
              <Mail className="w-4 h-4 text-sky-600" />
              <a href={`mailto:${settings.email}`} className="hover:text-sky-600">
                {settings.email}
              </a>
            </li>
            <li className="flex items-center gap-2" data-testid="footer-phone">
              <Phone className="w-4 h-4 text-sky-600" />
              <a href={`tel:${settings.phone.replace(/\s+/g, "")}`} className="hover:text-sky-600">
                {settings.phone}
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3">{t("nav.services")}</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li>
              <Link
                to="/services/driveway-pressure-washing"
                className="hover:text-sky-600"
              >
                {t("footer.driveway")}
              </Link>
            </li>
            <li>
              <Link to="/services/wheelie-bin-cleaning" className="hover:text-sky-600">
                {t("footer.bin")}
              </Link>
            </li>
            <li>
              <Link to="/admin/login" className="hover:text-sky-600 text-slate-400">
                {t("nav.admin")}
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200 py-4 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} LocalH2O · Gdańsk, Poland
      </div>
    </footer>
  );
}
